module.exports = __webpack_public_path__ + "static/how_it_works_fun_art@2x-2a8c044e0473b3491060c75cf02cafd1.png";